import { render } from "./TimeMachine.vue?vue&type=template&id=1454baa1"
import script from "./TimeMachine.vue?vue&type=script&lang=js"
export * from "./TimeMachine.vue?vue&type=script&lang=js"

import "./TimeMachine.vue?vue&type=style&index=0&id=1454baa1&lang=scss"

import exportComponent from "/home/callum/Documents/CODE/raphaelschoen/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__